/** Company domains that grant dashboard admin without a dashboardAdmins doc. */
const STAFF_ADMIN_SUFFIXES = ['@ixoragroup.com', '@loocafe.com'];

export function isStaffAdminEmail(email) {
  const key = email?.trim().toLowerCase();
  if (!key) return false;
  return STAFF_ADMIN_SUFFIXES.some((suffix) => key.endsWith(suffix));
}
